const crud = { c: false, r: false, u: false, d: false };

export const datasources = Object.freeze({
  datasource: { ...crud },
});
